import { connect } from 'react-redux';
import React, { useEffect } from 'react';
import { withRouter } from 'react-router-dom';

import HighligthPlans from '../../../../../components/search/plans_table/HighligthPlans';

import { fetchHighlightPlans, getCategory } from '../../../../../apiCalls';
import { storeHighligthPlans, addComparisonPlan, removeComparisonPlan, setQuotationParams, searchProviderSettings } from '../../../../../actions/searchActions';
import { getFilterSearchUrl } from '../../../../../utils';
import { calcCouponDiscount, maxValueParcel as planMaxValueParcel } from '../../../../../utils/plan';

import style from './styles.module.css';
import OrderPlanDropdown from '../orderPlanDropdown';
import Plan from '../plan';
import SpecialistBlock from '../../../../../components/search/plans_table/SpecialistBlock';
import ActiveFilters from '../../../../../components/search/plans_table/Filters/ActiveFilters';
import PlanSkeleton from './skeleton';
import matomoTracker from '../../../../../utils/matomo';
import dataLayer from '../../../../../utils/dataLayer';

const PlansTable = (props) => {
  const selectedPlans = (props.comparisonPlans || []).map((plan) => plan.code);

  const processHighlightPlans = (plans) => {
    return plans.map((plan) => {
      const priceWithDiscount = calcCouponDiscount(plan, props.coupon);
      const finalPrice = priceWithDiscount || plan.price.adult.price;

      return {
        ...plan,
        price_with_coupon_discount: priceWithDiscount,
        parcels: planMaxValueParcel(finalPrice),
      };
    });
  };

  useEffect(() => {
    const loadHighlightPlans = async () => {
      try {
        const highlightPlans = await fetchHighlightPlans(props.match.params);
        const processedPlans = processHighlightPlans(highlightPlans);
        props.storeHighligthPlans(processedPlans);
      } catch (error) {
        console.error('[PlansTable V2] Error fetching highlight plans:', error);
      }
    };

    loadHighlightPlans();
  }, [
    props.match && props.match.params && props.match.params.destination,
    props.match && props.match.params && props.match.params.begin_date,
    props.match && props.match.params && props.match.params.end_date,
  ]);

  useEffect(() => {
    if (props.highlightPlans.length > 0) {
      const processedPlans = processHighlightPlans(props.highlightPlans);
      props.storeHighligthPlans(processedPlans);
    }
  }, [props.coupon]);

  useEffect(() => {
    props.setQuotationParams({
      destination: props.match.params.destination,
      begin_date: props.match.params.begin_date,
      end_date: props.match.params.end_date,
      context: 'search',
      benefits: ['51', '42', '57', '55', '45', '56', '5', '68', '69'],
    });
  }, []);

  useEffect(() => {
    if (props.providers && props.providers.length > 0) {
      if (props.searchProviderSettings) {
        props.searchProviderSettings(props.providers);
      }

      try {
        const search = props.location ? props.location.search : window.location.search;
        const params = getFilterSearchUrl(search || '');
        getCategory(params);
      } catch (e) {
        console.error('[PlansTable V2] Erro ao aplicar filtros da URL:', e);
      }
    }
  }, [props.providers, props.location && props.location.search]);

  useEffect(() => {
    const { destination } = props.match.params || {};
    if (destination) {
      if (window._paq) {
        window._paq.push(['setEcommerceView', false, false, destination]);
      }
      matomoTracker.trackPageView(`Pesquisa: ${destination}`)
      dataLayer.pageView('search_results', `Pesquisa: ${destination}`);
    }
  }, [props.match && props.match.params && props.match.params.destination])

  useEffect(() => {
    const { destination } = props.match.params || {};
    if (props.filtered_plans && props.filtered_plans.length > 0 && destination) {
      dataLayer.viewItemList(props.filtered_plans, destination);
    }
  }, [props.filtered_plans && props.filtered_plans.length, props.match && props.match.params && props.match.params.destination])

  return (
    <div className={style.container}>
      <HighligthPlans
        mobile={props.mobile}
        providers={props.providers}
        match={props.match}
        selectedPlans={selectedPlans}
        addComparisonPlan={props.addComparisonPlan}
        removeComparisonPlan={props.removeComparisonPlan}
        userDetails={props.userDetails}
        plans={props.highlightPlans}
        variant="V2"
      />

      <div className={style.plansContainer}>
        <div className={style.plansHeader}>
          <div className={style.plansHeaderText}>
            {props.loading ? (
              <strong className={style.loadingText}>Buscando seguros viagem...</strong>
            ) : (
              <React.Fragment>
                <strong>
                  Encontramos {(props.filtered_plans && props.filtered_plans.length) || 0} <span>seguros viagem</span>
                </strong>
                <span>Escolhemos os melhores planos para sua viagem de acordo com seu destino e tempo de permanência.</span>
              </React.Fragment>
            )}
          </div>

          {!props.mobile && <OrderPlanDropdown />}
        </div>

        {props.mobile && <ActiveFilters />}

        <div className={`${style.plansList} ${props.showSpecialistSuggestions ? style.withSuggestions : ''}`}>
          {props.loading ? (
            <React.Fragment>
              <PlanSkeleton />
              <PlanSkeleton />
              <PlanSkeleton />
            </React.Fragment>
          ) : (
            props.mobile
              ? (() => {
                const list = props.filtered_plans || [];
                if (list.length === 0) return null;
                const [first, ...rest] = list;
                return (
                  <React.Fragment>
                    <Plan key={first.code || 'plan-0'} plan={first} match={props.match} />
                    <SpecialistBlock />
                    {rest.map((plan, idx) => (
                      <Plan key={plan.code || `plan-${idx + 1}`} plan={plan} match={props.match} />
                    ))}
                  </React.Fragment>
                );
              })()
              : (props.filtered_plans || []).map((plan, index) => (
                <Plan key={plan.code || index} plan={plan} match={props.match} />
              ))
          )}
          {props.filtered_plans && props.filtered_plans.length === 0 && !props.loading && (
            <div className={style.noPlansFound}>
              <strong>Ops!</strong>
              <span>Não há planos com a combinação de filtro selecionada para esta <br /> viagem, tente outra combinação.</span>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default withRouter(
  connect(
    (state) => ({
      plans: state.search.plans,
      loading: state.search.loading,
      end_date: state.search.end_date,
      providers: state.global.providers,
      begin_date: state.search.begin_date,
      destination: state.search.destination,
      sortOptions: state.search.sortOptions,
      sort_option: state.search.sort_option,
      filtered_plans: state.search.filtered_plans,
      suggestions_plans: state.search.suggestions_plans,
      comparisonPlans: state.search.comparisonPlans,
      searchState: state.search.searchState,
      mobile: state.mobile.mobileActive,
      userDetails: state.search.userDetails,
      providerOption: state.search.provider_option,
      filterCategory: state.search.filterCategory,
      filterProvider: state.search.filterProvider,
      highlightPlans: state.search.highlightPlans,
      benefits: state.purchase.benefits,
      coupon: state.purchase.coupon,
      showSpecialistSuggestions: state.search.showSpecialistSuggestions,
    }),
    {
      storeHighligthPlans,
      addComparisonPlan,
      removeComparisonPlan,
      setQuotationParams,
      searchProviderSettings,
    }
  )(PlansTable)
);



// WEBPACK FOOTER //
// ./src/views/v2/search/components/plansTable/index.jsx